import {AppState} from "../index";
import {IFeed, IFeedState} from "./types";
import {IdObjectsWithId} from "../../utils";
import {createSelector} from "reselect";
import isEqual from "lodash/isEqual"
import {getJsonPreview} from "./reducers";

export const selectActiveFeed = (state: AppState) => state.feed.activeFeed;

export const selectLiveFeeds = (state: AppState): IdObjectsWithId<IFeed> => {
    return state.feed.liveFeeds
};

export const selectSampleFeeds = (state: AppState): IdObjectsWithId<IFeed> => {
    return state.feed.sampleFeeds
};

export const selectFeedState = (state: AppState): IFeedState => {
    return state.feed
};

export const hasActiveFeedChanged = createSelector(
    [selectActiveFeed, selectLiveFeeds, selectSampleFeeds],
    (active, liveFeeds, sampleFeeds): boolean => {
        let origin = Object.values(sampleFeeds.byId).find(feed => feed.id === active.id)
        if (!origin) {
            return true
        }
        return !(active.id === origin.id &&
            active.name === origin.name &&
            active.json === getJsonPreview(origin.preview) &&
            isEqual(active.preview, origin.preview))
    })

